/**
 * NỘI DUNG TRANG CÔNG CỤ TẠO VIDEO SỨC KHỎE TAY CHỈ (/tools/tao-video-suc-khoe-tay-chi)
 *
 * Dùng chung trang VideoBatchToolPage với công cụ tạo video hàng loạt — cấu trúc trường giống
 * videoBatchToolContent.js. Trường để trống ('' hoặc []) thì trang tự ẩn phần tương ứng.
 *
 * File zip nằm trên máy chủ: web/back-end/storage/tools/Tool_Tao_Video_Suc_Khoe.zip (khai báo ở
 * pharmacy-tool.controller.js, DESKTOP_TOOLS['health-video-tool']). Người đã đăng nhập bấm tải thì API cấp link tạm
 * có hạn 5 phút (GET /pharmacy-tool/health-video-tool/download → /health-video-tool/file?t=...).
 *
 * published: false  → chỉ ADMIN thấy thẻ ở /tools và mở được trang (người khác bị chuyển về /courses);
 *                     API tải cũng chỉ cho ADMIN. Trang hiện dải "DEMO" (stage: 'demo') hoặc "BẢN NHÁP" (bỏ stage).
 * published: true   → hiện cho mọi người. Chỉ bật khi đã có zip trên máy chủ và đã đối chiếu các bước cài
 *                     đặt, tên file, yêu cầu máy bên dưới với bản zip thật. Bật cùng lúc phải đổi route
 *                     GET /health-video-tool/download từ `...adminOnly` sang `authenticate` (pharmacy-tool.routes.js).
 */
export const HEALTH_HAND_VIDEO_TOOL = {
  // Nội dung đối chiếu với mã nguồn công cụ ở docs/Suc-khoe-tay-chi-source (30/09/2026: HUONG_DAN.txt,
  // SETUP_FIRST_TIME.bat, giao diện app/main.py). Zip v1.1 (22/10/2026) thêm thư mục HUONG_DAN (Word + ảnh từng bước).
  // Phát hành 22/10/2026, bán lẻ 300.000đ / 12 tháng (TOOL_VIDEO_SUC_KHOE ở back-end tool-access.constant.js).
  published: true,
  // Nhãn khi chưa phát hành: 'demo' → thẻ ở /tools và dải đầu trang ghi "DEMO" thay cho "BẢN NHÁP"
  stage: 'demo',

  slug: 'tao-video-suc-khoe-tay-chi',
  // Tên file này, hiện trong dải "bản nháp" để ADMIN biết sửa ở đâu
  contentFile: 'healthHandVideoToolContent.js',
  // Tên trong công cụ (cửa sổ, biểu tượng Desktop): "Nhà máy tạo video sức khoẻ hàng loạt"
  name: 'Công Cụ Tạo Video Sức Khỏe Tay Viết',
  tagline: 'Gõ chủ đề sức khỏe, AI tự viết kịch bản, vẽ ảnh, đọc giọng và xuất video dọc TikTok / Reels có bàn tay chỉ vào từng ý',
  intro:
    'Cài một lần, dán khóa OpenAI, sau đó mỗi video chỉ cần gõ chủ đề và bấm 2 nút. Công cụ tự viết kịch bản, tạo ảnh minh họa, ' +
    'giọng đọc, nhạc nền, có bàn tay hoặc bác sĩ hoạt hình chỉ vào từng ý, rồi xuất file MP4 khung dọc. Làm hàng loạt bằng một file danh sách chủ đề. ' +
    'Công cụ do Thế Thảo Pharma xây dựng; phí AI do OpenAI tính vào tài khoản OpenAI của bạn.',
  // Phiên bản hiện trên trang — khớp zip trên máy chủ (DESKTOP_TOOLS['health-video-tool'])
  version: '1.1',
  fileSize: '11,7 MB',
  updatedAt: '22/10/2026',
  platforms: ['Windows 10/11 (64-bit)'],
  // Ảnh riêng (22/10/2026): ghép 3 khung hình video thật do công cụ làm ra, khổ 2:1 dùng cho cả thẻ ở /tools và banner trang
  image: '/images/tools/tool-video-suc-khoe-tay-chi-banner.jpg',
  heroBanner: '/images/tools/tool-video-suc-khoe-tay-chi-banner.jpg',

  highlights: [
    { value: '8', label: 'kiểu video: liệt kê, dấu hiệu → kết quả, so sánh, câu hỏi…' },
    { value: '2 nút', label: 'gõ chủ đề, bấm là ra video MP4' },
    { value: 'Tái dùng ảnh', label: 'ảnh đã tạo được dùng lại, càng làm nhiều càng đỡ tốn phí AI' },
  ],

  features: [
    { title: 'AI làm trọn video', desc: 'Từ một dòng chủ đề: tự viết kịch bản, vẽ ảnh minh họa, đọc giọng, chèn nhạc nền và xuất MP4 khung dọc.' },
    { title: 'Bàn tay chỉ vào từng ý', desc: 'Bàn tay, nét viết tay hoặc bác sĩ hoạt hình chỉ lần lượt vào từng mục, giữ mắt người xem theo nội dung.' },
    { title: 'Tái dùng ảnh, tiết kiệm phí', desc: 'Ảnh AI đã tạo được lưu vào kho trên máy. Video sau cần đúng vật đó thì dùng lại, không tốn phí tạo lại; công cụ báo số ảnh tái dùng và tiền tiết kiệm sau mỗi lần chạy.' },
    { title: 'Chạy hàng loạt', desc: 'Nạp file .txt mỗi dòng một chủ đề, bấm chạy là công cụ làm lần lượt từng video rồi mở thư mục kết quả.' },
  ],

  audience: [
    'Chủ nhà thuốc làm nội dung kiến thức sức khỏe cho khách hàng',
    'Nhân viên marketing chuỗi nhà thuốc cần ra nhiều video mỗi tuần',
  ],

  requirements: [
    { label: 'Hệ điều hành', value: 'Windows 10/11 (64-bit). Chưa có bản macOS' },
    { label: 'Internet', value: 'Cần cả khi cài và khi tạo video (AI chạy trên máy chủ OpenAI)' },
    { label: 'Khóa OpenAI (API Key)', value: 'Tài khoản platform.openai.com đã nạp tiền, tối thiểu 5 USD bằng thẻ Visa/Master' },
    { label: 'Ổ cứng trống', value: 'Khoảng 1 GB (Python, thư viện, ffmpeg tự cài; chưa tính video tạo ra)' },
    { label: 'Quyền máy', value: 'Không cần quyền Admin — công cụ tự cài Python cho tài khoản đang dùng' },
  ],

  // Các bước cài đặt trên Windows — khớp HUONG_DAN.txt / HUONG_DAN_NHANH.txt trong zip
  installSteps: [
    {
      title: 'Tải và giải nén',
      desc: 'Bấm "Tải công cụ" (cần đăng nhập) để tải file zip. Chuột phải vào file → "Extract All…" (Giải nén tất cả), để ra Desktop hoặc ổ D.',
      tip: 'Không chạy file bên trong file zip — phải giải nén ra trước.',
    },
    {
      title: 'Cài đặt — chạy một lần duy nhất',
      desc: 'Bấm đúp "SETUP_FIRST_TIME.bat". Công cụ tự cài Python, thư viện và ffmpeg, mất 3–10 phút tùy mạng. Thấy chữ xanh "CAI DAT XONG!" là xong; ngoài Desktop có biểu tượng "Nhà máy tạo video sức khoẻ hàng loạt".',
      tip: 'Nếu Windows hiện "Windows protected your PC": bấm "More info" → "Run anyway". Báo chữ đỏ "CO LOI" thì kiểm tra mạng rồi chạy lại.',
    },
    {
      title: 'Lấy khóa OpenAI',
      desc: 'Vào platform.openai.com, đăng nhập. Mục Billing: nạp tối thiểu 5 USD. Vào platform.openai.com/api-keys → "Create new secret key", copy dãy bắt đầu bằng "sk-".',
      tip: 'Không gửi khóa cho ai — ai có khóa sẽ tiêu được tiền trong tài khoản OpenAI của bạn.',
    },
    {
      title: 'Dán khóa vào công cụ',
      desc: 'Bấm đúp biểu tượng "Nhà máy tạo video sức khoẻ hàng loạt" ngoài Desktop. Bấm tab "Cài đặt", dán khóa vào ô "OpenAI API Key", bấm "LƯU". Các ô khác để nguyên.',
      tip: 'Cửa sổ đen phía sau là bình thường, đừng tắt khi đang dùng.',
    },
    {
      title: 'Tạo video',
      desc: 'Tab "Tạo MP4": chọn "Định dạng Video" (ô chủ đề tự hiện ví dụ), gõ chủ đề theo kiểu ví dụ. Bấm "1. PLAN + ASSET + VOICE", đợi báo "Plan hoàn thành"; bấm "2. RENDER MP4", đợi "HOÀN THÀNH" — video tự mở ra, lưu ở thư mục data\\output.',
      tip: 'Làm nhiều video: mỗi dòng một chủ đề trong file .txt (lưu Encoding UTF-8) → "IMPORT DANH SÁCH (.txt)" → "CHẠY HÀNG LOẠT".',
    },
  ],

  // Chưa có bản macOS — để trống thì trang ẩn tab macOS
  installStepsMac: [],

  // Video hướng dẫn trên YouTube (chỉ điền phần ID, ví dụ 'dQw4w9WgXcQ'). Để trống thì ẩn khung video.
  youtubeVideoId: '',

  faqs: [
    {
      q: 'Công cụ có mất phí không?',
      // Giá chốt 22/10/2026 — khớp TOOL_VIDEO_SUC_KHOE ở back-end
      a: 'Công cụ có giá 300.000đ, dùng và tải lại nhiều lần trong 12 tháng. Ngoài ra phần AI (viết kịch bản, vẽ ảnh, giọng đọc) do OpenAI tính phí theo lượt vào tài khoản OpenAI của bạn; sau mỗi lần chạy, công cụ hiện chi phí ước tính ở dòng "API estimate".',
    },
    {
      q: 'Làm sao để đỡ tốn phí AI?',
      a: 'Phần tốn nhất là tạo ảnh. Mỗi ảnh tạo xong được lưu vào kho (thư mục data\\assets\\images); video sau cần đúng vật thể đó thì công cụ tự dùng lại ảnh cũ, không tính phí tạo lại — nên làm càng nhiều video cùng mảng (thực phẩm, giấc ngủ, gan…) càng rẻ. Nếu kho ảnh không có ảnh khớp, công cụ mới tạo ảnh mới để video vẫn đúng nội dung. Dòng "API image estimate" cho biết số ảnh TẠO MỚI / TÁI DÙNG và số tiền tiết kiệm. Có sẵn ảnh .png thì bấm "IMPORT KHO ẢNH" để nạp thêm vào kho. Chất lượng ảnh mặc định là "low" (rẻ nhất), đủ nét cho video dọc.',
    },
    {
      q: 'Nên gõ chủ đề thế nào?',
      a: 'Gõ theo đúng kiểu ví dụ hiện ra khi chọn định dạng. Ví dụ: Liệt kê 8 mục — "8 thực phẩm tốt cho gan"; Dấu hiệu → Kết quả — "4 dấu hiệu trên móng tay cảnh báo thiếu vi chất"; Câu hỏi + So sánh — "Ổi hay cam, loại nào nhiều vitamin C hơn?". Chỉ làm mẹo sức khỏe, thực phẩm, thói quen; không ghi tên thuốc, liều dùng (quy định quảng cáo).',
    },
    {
      q: 'Báo lỗi có chữ "api_key" hoặc "401"?',
      a: 'Chưa dán khóa, khóa sai, hoặc quên bấm "LƯU" ở tab "Cài đặt". Dán lại khóa "sk-…" rồi bấm LƯU.',
    },
    {
      q: 'Báo lỗi có chữ "429", "quota" hoặc "billing"?',
      a: 'Tài khoản OpenAI hết tiền. Vào platform.openai.com, mục Billing, nạp thêm.',
    },
    {
      q: 'Mở công cụ báo "Chua cai dat"?',
      a: 'Máy chưa cài xong. Chạy lại "SETUP_FIRST_TIME.bat"; vẫn lỗi thì khởi động lại máy rồi chạy lại.',
    },
    {
      q: 'Nhập danh sách chủ đề báo "Lỗi đọc file"?',
      a: 'File .txt chưa lưu dạng UTF-8. Mở file bằng Notepad → File → Save As → ô Encoding chọn UTF-8 → Save, rồi nhập lại.',
    },
    {
      q: 'Mỗi video mất bao lâu?',
      a: 'Vài phút mỗi video, tùy máy và mạng. Cứ để máy chạy, không tắt cửa sổ đen.',
    },
    {
      q: 'Máy Mac có dùng được không?',
      a: 'Hiện công cụ chỉ có bản Windows.',
    },
  ],

  support: {
    text: 'Cài đặt gặp khó khăn? Gọi hoặc nhắn Zalo đội hỗ trợ kèm ảnh chụp màn hình lỗi.',
    phone: '0812539539',
    phoneLabel: '0812.539.539',
  },

  ctaTitle: 'Sẵn sàng làm video sức khỏe hàng loạt?',
  ctaText: 'Tải công cụ, cài trong khoảng 15 phút và gõ chủ đề đầu tiên.',
};
